import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalHeader } from "reactstrap"

const CustomModal = ({
  children,
  size,
  modal,
  title,
  classBackground,
  onToggle,
  customClass,
  centered = true,
  fullscreen
}) => {
  return (
    <Modal fullscreen={fullscreen} centered={centered} scrollable={true} size={size} isOpen={modal} className={customClass}>
      <ModalHeader className={classBackground} toggle={onToggle} tag="h5">
        {title}
      </ModalHeader>
      {children}
    </Modal>
  )
}

CustomModal.propTypes = {
  size: PropTypes.string,
  modal: PropTypes.bool,
  title: PropTypes.string,
  classBackground: PropTypes.string,
  onToggle: PropTypes.func,
}

CustomModal.defaultProps = {
  size: "lg",
  classBackground: "",
  children: <h6>children</h6>,
  onToggle: () => { },
}

export default CustomModal
